import { useState } from "react";
import { Send } from "lucide-react";
import { apiRequest } from "../api";

export function LeadForm({ productSlug, mode = "contact" }: { productSlug?: string; mode?: "contact" | "inquiry" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("");
  const update = (key: string, value: string) => setForm((current) => ({ ...current, [key]: value }));
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setStatus("Sending…");
    try {
      const result = await apiRequest<{ id: string }>("/leads", { method: "POST", body: JSON.stringify({ ...form, source: mode, product_slug: productSlug }) });
      setStatus(`Request received: ${result.id.slice(0, 8).toUpperCase()}`);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (error) { setStatus(error instanceof Error ? error.message : "Unable to send"); }
  };
  return (
    <form className="lux-form" onSubmit={submit} data-testid={`${mode}-lead-form`}>
      <input required value={form.name} onChange={(e) => update("name", e.target.value)} placeholder="Full name" data-testid={`${mode}-name-input`} />
      <input required type="email" value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="Email address" data-testid={`${mode}-email-input`} />
      <input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="Phone optional" data-testid={`${mode}-phone-input`} />
      <textarea required value={form.message} onChange={(e) => update("message", e.target.value)} placeholder="Tell us about the product, room, or brand you need." data-testid={`${mode}-message-textarea`} />
      <button className="primary-button" type="submit" data-testid={`${mode}-submit-button`}><Send size={16} strokeWidth={1.5}/> Send request</button>
      {status && <p className="form-status" data-testid={`${mode}-form-status`}>{status}</p>}
    </form>
  );
}